import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-create-draw-controls.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import VelavuButton from "../../../../elements/velavu-button";
import PlanToolType from "../../../../state/floor/plan-tool-type";
import ReferenceFloor from "../../../../state/floor/reference-floor";
import FloorInputDraw from "../floor-input/floor-input-draw";

export interface FloorCreateDrawControlsProps {
	onClose?: () => void;
	onFinish?: () => void;

	drawTool: PlanToolType;
	onChangeDrawTool: (tool: PlanToolType) => void;

	disableFinish: boolean;

	floors: ReferenceFloor[];
	referenceFloorID: string | null;
	onSelectReferenceFloor?: (floorID: string | null) => void;
}

export default function FloorCreateDrawControls(
	props: FloorCreateDrawControlsProps,
) {
	const { t } = useTranslation();

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_create.draw_header")}
				onClose={props.onClose}
			/>
			<div className={styles.content}>
				<FloorInputDraw
					drawTool={props.drawTool}
					onChangeDrawTool={props.onChangeDrawTool}
					floors={props.floors}
					referenceFloorID={props.referenceFloorID}
					onSelectReferenceFloor={props.onSelectReferenceFloor}
				/>

				<VelavuButton
					label={t("dashboard.floor_create.finish")}
					disabled={props.disableFinish}
					loadingIndicator={props.disableFinish}
					onClick={props.onFinish}
					fullWidth
				/>
			</div>
		</PinnedList>
	);
}
